import * as R from "ramda"
import React from "react"
import cn from "classnames"
import PropTypes from "prop-types"

import i18n from "@cirrus/legacy/features/core/shared/utils/i18n"
import { Icon, Link } from "@cirrus/legacy/app-components/entries/lib.js"

import styles from "./styles.less"

export const ErrorResultMessage = ({
  className = styles.errorResultMessage,
  errorMessage = i18n("General:DataFetchFailed"),
  tryAgainMessage = i18n("General:TryAgain"),
  action,
  pending,
}) => {
  return (
    <div className={cn(styles.container, className)}>
      {errorMessage}

      <Link onClick={action} className={styles.buttonWrapper}>
        <div className={styles.button}>{R.toLower(tryAgainMessage)}</div>

        <Icon className={styles.tryAgainIcon} icon="fa-refresh" spin={pending} />
      </Link>
    </div>
  )
}

ErrorResultMessage.propTypes = {
  className: PropTypes.string,
  errorMessage: PropTypes.string,
  tryAgainMessage: PropTypes.string,
  action: PropTypes.func.isRequired,
  pending: PropTypes.bool.isRequired,
}
